import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ProfessionalCategory } from "../_types/professional-category";

@Injectable({
  providedIn: 'root',
})
export class ProfessionalCategoriesService extends Service<ProfessionalCategory> {
  public override type = 'professionalCategories';
  public override url = 'common/professionalCategories';
}
